import { createFileRoute, redirect } from "@tanstack/react-router"

/** IP bans moved under the moderation hub; this only serves old bookmarks. */
export const Route = createFileRoute("/ip-bans")({
	beforeLoad: () => {
		throw redirect({ to: "/moderation/ip-bans" })
	},
})
